import { FC, useEffect } from 'react';
import i18n from 'i18next';
import { useVersion } from 'mir-utils/api-tools';
import { Loading } from 'mir-utils/components';
import { getI18nLocale } from 'mir-utils/i18n';
import { LOCAL_STORAGE_LANGUAGE_KEY } from '../../i18n';

export const LocaleProvider: FC = ({ children }) => {
  const version = useVersion();

  useEffect(() => {
    if (version !== undefined) {
      const language = getI18nLocale(version.language);
      window?.localStorage?.setItem(LOCAL_STORAGE_LANGUAGE_KEY, language);
      i18n.changeLanguage(language);
    }
  }, [version?.language]);

  if (version === undefined) {
    return <Loading />;
  }

  return <>{children}</>;
};
